import { useQuery } from '@tanstack/react-query';

import { checklistApi } from '@features/Checklist/api';

export const useGetChecklistData = (positionGuid: string) =>
    useQuery({
        ...checklistApi.getChecklistDataQuery({ positionGuid }),
        retry: 1,
        enabled: Boolean(positionGuid),
    });
